// This slice manages computed vehicle state

import { IVehicleChargeStatus, IVehicleDetails } from '@common/interfaces';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface VehicleDetailsState {
  vehicleDetails: IVehicleDetails;
}

const initialState: VehicleDetailsState = {
  vehicleDetails: {
    isUsedCar: false,
    selectedSerialNo: null,
    vehicleAvailabilityCode: null,
    vehicleChargeStatus: null,
  },
};

const vehicleDetailsSlice = createSlice({
  name: 'vehicleDetails',
  initialState,
  reducers: {
    setVehicleDetails: (state, action: PayloadAction<IVehicleDetails>) => {
      state.vehicleDetails = action.payload;
    },
    setIsUsedCar: (state, action: PayloadAction<boolean>) => {
      state.vehicleDetails.isUsedCar = action.payload;
    },
    setSelectedSerialNo: (state, action: PayloadAction<number>) => {
      state.vehicleDetails.selectedSerialNo = action.payload;
    },
    setVehicleAvailabilityCode: (state, action: PayloadAction<string>) => {
      state.vehicleDetails.vehicleAvailabilityCode = action.payload;
    },
    setVehicleChargeStatus: (state, action: PayloadAction<IVehicleChargeStatus>) => {
      state.vehicleDetails.vehicleChargeStatus = action.payload;
    },
  },
});

export const {
  setVehicleDetails,
  setIsUsedCar,
  setSelectedSerialNo,
  setVehicleAvailabilityCode,
  setVehicleChargeStatus,
} = vehicleDetailsSlice.actions;
export default vehicleDetailsSlice.reducer;
